import { FC } from 'react';
import '../ArticleComponent.scss';
import './Article5.scss';
import { Section1, Section2, Section3, Section4, Section5, Images, Links } from './article5_model';
import { ButtonComponent } from '../../../UI/ButtonComponent/ButtonComponent';

const Article5Component: FC = () => {
	const handleNavigate = () => {
		window.open(Links.button_contact_us, '_blank', 'noopener');
	};
	const handleImgBeaconDiscovery = () => {
		window.open(Links.beacon_discovery, '_blank', 'noopener');
	};
	return (
		<div className='page five'>
			<div className='section--intro'>
				<div className='section-container'>
					<h3 className='section-heading'>{Section1.heading}</h3>
					<p className='info-600'>
						<span>{Section1.para1.content1}</span>
						<a href={Links.beacon_discovery} className='info-600' target='_blank' rel='noopener'>
							{Section1.para1.content2_link}
						</a>
						<span>{Section1.para1.content3}</span>
					</p>

					<p className='info-400'>
						<span>{Section1.para2.content1}</span>
						<span className='info-700'>{Section1.para2.content2_bold}</span>
						<span>{Section1.para2.content3}</span>
					</p>
				</div>
			</div>

			<div className='section--image-right-wave five--first'>
				<div className='section-container'>
					<h3 className='section-heading'>{Section2.heading}</h3>

					<div className='imageRightContentLeft nospace-top'>
						<div className='content'>
							<ul>
								<li>
									<span className='info-700'>{Section2.l1.boldcontent}</span>
									<span className='info-400'>{Section2.l1.content}</span>
								</li>
								<li>
									<span className='info-700'>{Section2.l2.boldcontent}</span>
									<span className='info-400'>{Section2.l2.content}</span>
								</li>
								<li>
									<span className='info-700'>{Section2.l3.boldcontent}</span>
									<span className='info-400'>{Section2.l3.content}</span>
								</li>
							</ul>
						</div>
						<div className='image'>
							<img src={Images.natural_brand} alt='Filters' onClick={handleImgBeaconDiscovery} />
						</div>
					</div>
				</div>
			</div>

			<div className='section--noimage five--second'>
				<div className='section-container nospace-bottom'>
					<h3 className='section-heading'>{Section3.heading}</h3>

					<p className='info-400'>{Section3.content}</p>
				</div>
			</div>

			<div className='section--noimage five--third'>
				<div className='section-container nospace-bottom'>
					<h3 className='section-heading'>{Section4.heading}</h3>
					<p className='info-600'>{Section4.content1}</p>

					<p className='info-400 nospace-bottom'>
						<ol type='1'>
							<li>
								<span>{Section4.l1.content}</span>
								<a href={Links.form_alchemer} target='_blank' rel='noopener'>
									{Section4.l1.content_link}{' '}
								</a>
								.
							</li>
							<li>
								<span>{Section4.l2.content}</span>
								<ol type='a'>
									<li className='type-a'>
										<span className='info-700'>{Section4.l2.subcontent.l1.bold}</span>
										<span>{Section4.l2.subcontent.l1.content}</span>
									</li>
									<li className='type-a'>
										<span className='info-700'>{Section4.l2.subcontent.l2.bold}</span>
										<span>{Section4.l2.subcontent.l2.content}</span>
									</li>
								</ol>
							</li>
							<li>
								<span>{Section4.l3.content}</span>
							</li>
							<li>
								<span>{Section4.l4.content}</span>
							</li>
						</ol>
					</p>
				</div>
			</div>

			<div className='section--noimage'>
				<div className='section-container'>
					<h3 className='section-heading'>{Section5.heading}</h3>
					<p className='info-400'>{Section5.content}</p>
					<div className='button-container'>
						<ButtonComponent
							text={'GET READY TO BE DISCOVERED!'}
							onClick={handleNavigate}
							style={'rounded-button primary addToCart'}
							icon={<i className='ri-arrow-right-s-line arrowIcon'></i>}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Article5Component;
